import cloneDeep from 'lodash/cloneDeep';
import compact from 'lodash/compact';

/* eslint-disable object-curly-newline */
const orderStatusDropdownOptions = [
  { id: 1, name: 'COMPLETED', value: 'COMPLETED' },
  { id: 2, name: 'NEW', value: 'NEW' },
  { id: 3, name: 'PAYMENT PENDING', value: 'PAYMENT_PENDING' },
  { id: 4, name: 'PROCESSED', value: 'PROCESSED' },
  { id: 5, name: 'RECEIVED', value: 'RECEIVED' },
  { id: 6, name: 'READY', value: 'READY' },
  { id: 7, name: 'CANCELED', value: 'CANCELED' },
];

const productsCustomizationViewDropdownOptions = [
  { id: 1, name: 'Step View', value: 'STEP_VIEW' },
  { id: 2, name: 'Inline View', value: 'INLINE_VIEW' },
  { id: 3, name: 'Regular View', value: 'REGULAR_VIEW' },
];

const widthPercentageDropdownOptions = [
  { id: 1, name: 'Half Width (50%)', value: 50 },
  { id: 2, name: 'Full Width (100%)', value: 100 },
];

const componentDropdownOptions = [
  { id: 1, name: 'Product', value: 'PRODUCT' },
  { id: 2, name: 'Half and half', value: 'HALF_AND_HALF' },
  { id: 3, name: 'Create your own', value: 'CREATE_YOUR_OWN' },
];

const maxQuantityOptions = [
  { id: 1, name: 'One', value: 1 },
  { id: 2, name: 'Two', value: 2 },
  { id: 3, name: 'Three', value: 3 },
];

const toolTips = {
  products: {
    name: 'Name of this product visible to guests.',
    category: 'The category where this product is listed.',
    locations: 'The locations where this product is available.',
    productTax: 'Applicable taxes added to this product.',
    widthPercentage: 'Half-width shows two products per row; full-width shows two products per row.',
    position: 'The order in which this product appears. For example, a product with position order 1 will appear first.',
    component: '',
    customizationView: '',
    description: 'Description of this product visible to guests. For example, a list of ingredients used in this product.',
    timeLimits: 'When this item is available to be ordered',
    icons: 'Add dietary-restriction icons (such as Gluten Free, Vegetarian, etc.) to this product.',
    outOfStock: 'Products marked as out of stock are visible to guests, but not available for purchase.',
    isDisabled: 'Products marked as disabled are not visible to guests.',
    showNote: '',
  },
  items: {
    name: 'Specific name for this variation of the product.',
    attribute_name: 'The variation of this product. For example, Size or Kind.',
    attribute_value: 'The value of this variation. For example, 12oz, Large, or Red.',
    price: 'Price of this item.',
    points: 'The number of points necessary to redeem this item.',
    integrationSizeCode: 'Square customers only: Your Square Dashboard will automatically populate this token. If you are importing a new item, leave this field blank, if you are editing items do not change the token.',
    prepTime: 'The amount of time necessary to prepare this item.',
    integrationPLU: 'Square customers only: Your Square Dashboard will automatically populate this token. If you are importing a new item, leave this field blank, if you are editing items do not change the token.',
    isDefault: 'Each product must have at least one default item.',
    isDisabled: 'Items marked as disabled are not visible to guests.',
    tier: 'Reward tier(s) this item belongs to, if applicable.',
    position: 'The order in which this item appears. For example, an item with position order 1 will appear first.',
    customizations: '',
    includedOptions: '',
  },
  itemCustomizations: {
    minOptions: 'The minimum number of options permitted for selection.',
    maxOptions: 'The maximum number of options permitted for selection.',
    position: 'The order in which this customization appears. For example, a customization with position order 1 will appear first.',
    isMandatory: 'If selected, guests are required to choose an option before adding this item to the cart.',
    freeOptions: '',
  },
  categories: {
    name: 'Name of this category visible to guests.',
    categoryTax: 'Applicable tax added to all items in this category.',
    widthPercentage: 'Half-width shows two items per row; full-width shows two items per row.',
    position: 'The order in which this category appears. For example, a category with position order 1 will appear first.',
    prepTime: 'The amount of time necessary to prepare any item in this category.',
    quantityThreshold: 'The quantity of items for which this prep time applies. For example, a Quantity Threshold of 3 would indicate that a maximum of 3 of these items can be prepared in the given Prep Time.',
    orderTypes: 'The types of of orders that are enabled for this category.',
    description: 'Description of the category visible to guests. For example, the type of items in this category.',
    timeLimits: 'When items in this category are available to be ordered.',
    isDisabled: 'Categories marked as disabled are not visible to guests.',
  },
  customizations: {
    name: 'Name of this customization. Not visible to guests.',
    title: 'Title of this customization. Visible to guests.',
    minOptions: 'The minimum number of options permitted for selection.',
    maxOptions: 'The maximum number of options permitted for selection.',
    position: 'The order in which this customization appears. For example, a customization with position order 1 will appear first.',
    isMandatory: 'If selected, guests are required to choose an option before adding this item to the cart.',
    useLeftRightOptions: 'Show pizza topping options: Left, Whole, Right.',
    description: 'Description of this customization visible to guests.',
    isSingleSelectDefault: 'Use a pre-selected value when only one value can be selected',
  },
  options: {
    name: 'Name of this option. Visible to guests.',
    customizations: 'Modifiers associated with this option',
    outOfStock: 'Options marked as out of stock are visible to guests, but not available for purchase.',
    priceAddOn: '',
    description: 'Description of this option visible to guests.',
    integrationPLU: '',
    position: 'The order in which this option appears. For example, an option with position order 1 will appear first.',
    maxQuantity: '',
  },
  taxes: {
    name: 'Name of this tax.',
    percentage: 'Amount of this tax as a percentage. For example, enter 7 for a 7 % tax.',
  },
  orders: {
    orderStatus: 'Status of this order.',
  },
  locations: {
    name: 'Name of this location.',
    phone: 'Phone number of this location.',
    address: 'Address of this location.',
    timezone: 'Timezone of this location.',
    payNowAvailable: 'Customers can pay through the mobile app instead of with a POS at your physical location.',
    payAtDoorAvailable: 'For delivery, customers can pay at the address you deliver to. For pickup, customers can pay at your physical location.',
    payAtDoorOptions: 'E.g. Cash, Credit, Debit. Applies to both delivery and pickup, whether you offer one or both.',
    squareId: '',
    currencyCode: '',
    deliveryTime: 'Estimated delivery time for each order.',
    pickupTime: 'Estimated pickup time for each order.',
    reportFrequency: 'Reports of all orders from this location are sent according to the frequency selected.',
    reportRecipients: 'Comma-separated list of all report recipients\' email addresses. For example: test@example.com,test2@example.com',
    orderNotificationRecipients: 'Comma-separated list of all notification recipients. Notification is sent when an order is placed. For example: test@example.com,test2@example.com',
    emergencyTitle: 'Emergency notification title. If selected, guests will see an emergency message.',
    emergencyMessage: 'Emergency notification text. If selected, guests will see this emergency message.',
    hours: 'The opening and delivery hours of this location.',
  },
  zones: {
    name: 'Name of this delivery zone.',
    fee: '',
    minimum: '',
    coordinates: '',
    below_minimum_fee: '',
  },
  'catering-zones': {
    name: 'Name of this catering zone.',
  },
  users: {
    name: 'Name of this guest.',
    email: 'Email address of this guest.',
    telephone: 'Phone number of this guest.',
    points: 'Number of points in this guest\'s account.',
    addresses: 'Addresses listed in this guest\'s account.',
  },
  addresses: {
    nickname: '',
    buzzer_number: '',
    street_address: '',
    unit_number: '',
    city: '',
    province: '',
    postal_code: '',
    country: '',
    comments: '',
  },
  tiers: {
    points: 'Number of points required for this reward tier.',
    name: 'Name of this reward tier.',
    description: 'Description of this reward tier.',
    rewardType: '',
    dollarAmount: '',
  },
  coupons: {
    code: 'Coupon code used for redemption of this coupon, if auto-apply is not selected.',
    title: 'Title of this coupon.',
    description: 'Description of this coupon.',
    exclusive: 'If selected, this coupon cannot be used in conjunction with any other coupon.',
    autoApply: 'If selected, this coupon will be automatically applied when specified conditions are satisfied.',
    actionType: 'Type of discount awarded by this coupon (must be either % or $).',
    actionValue: 'Value of discount awarded by this coupon.',
  },
  restrictions: {
    type: '',
    value: '',
  },
};

// Instructions, unlike tooltips, render immediately so that the user immediately gets information
export const instructions = {
  restrictionTypes: {
    MIN_PURCHASE: "The order's total amount must be higher than this amount.",
    PER_USER: 'Each user account can use this coupon this many times at most.',
    APPLY_TO_EACH_ITEM: 'Use this when you want to add discounts for each order line item, instead of the whole order. Usually used when the coupon type is dollar rather than percentage.',
    START_DATETIME: 'The date and time when the coupon starts working.',
    END_DATETIME: 'The date and time when the coupon expires.',
    START_TIME_OF_DAY: 'The time of day when a coupon starts working, such as your opening time.',
    END_TIME_OF_DAY: 'The time of day when a coupon stops working, such as your closing time.',
    DAYS_OF_WEEK: '',
    DELIVERY_TYPE: '',
    FIRST_ORDER_OF_CUSTOMER: 'This coupon applies to the first order the customer makes with the app, to encourage them to sign up and use it.',
    // This is to be ignored for the moment
    // ITEMS_COUNT_DEVIDED_BY: '',
    MAX_ITEMS_COUNT: 'When using this coupon, the user can buy a maximum of this many line items.',
    CATEGORY: 'The coupon applies to these categories of your menu.',
    PRODUCT: 'The coupon applies to these products in your menu.',
    PRODUCT_ITEM: 'The coupon applies to these product item variations in your menu.',
    EXCLUDE_CATEGORY: 'The coupon does not apply to these categories in your menu.',
    EXCLUDE_PRODUCT: 'The coupon does not apply to these products in your menu.',
    EXCLUDE_PRODUCT_ITEM: 'The coupon does not apply to these product item variations in your menu.',
    LOCATIONS: 'The coupon can only be used at these locations.',
    USERS: 'The coupon applies to these users',
  },
};

export const resourceFields = {
  locations: [
    { key: 'name', title: 'Name', gridWidth: '6', isRequired: true, toolTip: toolTips.locations.name },
    { key: 'phone', title: 'Phone', gridWidth: '6', toolTip: toolTips.locations.phone },
    { key: 'address', title: 'Address', gridWidth: '12', isRequired: true, toolTip: toolTips.locations.address },
    { key: 'timezone', title: 'Timezone', hideInDisplay: true, gridWith: '6', toolTip: toolTips.locations.timezone, hideInEdit: true },
    { key: 'payNowAvailable', title: 'Pay Now Available', hideInDisplay: true, type: 'boolean', gridWidth: '6', toolTip: toolTips.locations.payNowAvailable },
    { key: 'payAtDoorAvailable', title: 'Pay at Door Available', hideInDisplay: true, type: 'boolean', gridWidth: '6', toolTip: toolTips.locations.payAtDoorAvailable },
    { key: 'payAtDoorOptions', title: 'Pay at Door Options', hideInDisplay: true, type: 'dropdown', allowMultiple: true, gridWidth: '6', toolTip: toolTips.locations.payAtDoorOptions },
    { key: 'squareId', title: 'Square ID', gridWidth: '6', hideInDisplay: true, toolTip: toolTips.locations.squareId },
    { key: 'currencyCode', title: 'Currency', type: 'dropdown', gridWidth: '6', hideInDisplay: true, toolTip: toolTips.locations.currencyCode },
    { key: 'deliveryTime', title: 'Estimated delivery time (minutes)', type: 'number', gridWidth: '6', toolTip: toolTips.locations.deliveryTime },
    { key: 'pickupTime', title: 'Estimated pickup time (minutes)', type: 'number', gridWidth: '6', toolTip: toolTips.locations.pickupTime },
    { key: 'reportFrequency', title: 'Report Frequency', type: 'dropdown', gridWidth: '4', hideInDisplay: true, toolTip: toolTips.locations.reportFrequency },
    { key: 'reportRecipients', title: 'Report Recipients', gridWidth: '8', hideInDisplay: true, toolTip: toolTips.locations.reportRecipients },
    { key: 'orderNotificationRecipients', title: 'Order Notification Recipients', hideInDisplay: true, gridWidth: '12', toolTip: toolTips.locations.orderNotificationRecipients },
    { key: 'emergencyTitle', title: 'Emergency Message Title', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.locations.emergencyTitle },
    { key: 'emergencyMessage', title: 'Emergency Message', type: 'longText', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.locations.emergencyMessage },
    { key: 'DELIVERY_WINDOW', title: 'Delivery Window', type: 'number', gridWidth: '6', hideInDisplay: true },
    { key: 'PICKUP_WINDOW', title: 'Pickup Window', type: 'number', gridWidth: '6', hideInDisplay: true },
    { key: 'hours', title: 'Location Hours', type: 'hours', hideInDisplay: true, gridWidth: '12', toolTip: toolTips.locations.hours },
    { key: 'holidayHours', title: 'Holiday Hours', type: 'holidayHours', hideInDisplay: true, gridWidth: '12' },
    { key: 'orderNotification', title: 'Order Notification Recipient', hideInDisplay: true, gridWidth: '3' },
    { key: 'salesReport', title: 'Sales Report Recipient', hideInDisplay: true, gridWidth: '3' },
  ],
  customizations: [
    { key: 'name', title: 'Name', createEditPageSectionIndex: 1, gridWidth: '6', isRequired: true, toolTip: toolTips.customizations.name },
    { key: 'title', title: 'Title', createEditPageSectionIndex: 1, hideInDisplay: true, gridWidth: '6', toolTip: toolTips.customizations.title },
    { key: 'minOptions', title: 'Minimum Selectable Modifier Options', createEditPageSectionIndex: 1, type: 'number', gridWidth: '3', toolTip: toolTips.customizations.minOptions },
    { key: 'maxOptions', title: 'Maximum Selectable Modifier Options', createEditPageSectionIndex: 1, type: 'number', gridWidth: '3', toolTip: toolTips.customizations.maxOPtions },
    { key: 'key', title: 'Key', createEditPageSectionIndex: 1, hideInDisplay: true, hideInView: true, hideInEdit: true, gridWidth: '3', toolTip: toolTips.customizations.key },
    { key: 'position', title: 'Position Ordering', createEditPageSectionIndex: 1, type: 'nonZeroInt', hideInDisplay: true, gridWidth: '3', toolTip: toolTips.customizations.position },
    { key: 'description', title: 'Description', createEditPageSectionIndex: 1, hideInDisplay: true, type: 'longText', gridWidth: '12', toolTip: toolTips.customizations.description },
    { key: 'productItems', title: 'Attached Items', createEditPageSectionIndex: 1, hideInDisplay: true, type: 'searchable', gridWidth: '12' },
    { key: 'isMandatory', title: 'Is Mandatory', createEditPageSectionIndex: 2, type: 'boolean', gridWidth: '4', toolTip: toolTips.customizations.isMandatory },
    { key: 'isSingleSelectDefault', title: 'Default Value Selected', createEditPageSectionIndex: 3, type: 'boolean', hideInDisplay: true, gridWidth: '4', toolTip: toolTips.customizations.isSingleSelectDefault },
    { key: 'useLeftRightOptions', title: 'Use Left Right Options', createEditPageSectionIndex: 4, type: 'boolean', hideInDisplay: true, gridWidth: '4', tooltip: toolTips.customizations.useLeftRightOptions },
    { key: 'options', title: 'Modifier Options', hideInEdit: true, gridWidth: '12', shouldWrapNewLines: true },
  ],
  options: [
    { key: 'name', title: 'Name', gridWidth: '3', toolTip: toolTips.options.name, isRequired: true },
    { key: 'priceAddOn', title: 'Price Add On', type: 'decimal', helperText: 'e.g. Enter 2.15 for $2.15', gridWidth: '6', toolTip: toolTips.options.priceAddOn },
    { key: 'customizations', title: 'Associated Modifier Groups', type: 'dropdown', allSelectedDisplayValue: 'All Modifiers', gridWidth: '6', allowMultiple: true, toolTip: toolTips.options.modifiers },
    { key: 'outOfStock', title: 'Out of Stock', type: 'dropdown', allSelectedDisplayValue: 'All Locations', gridWidth: '6', allowMultiple: true, toolTip: toolTips.options.outOfStock },
    { key: 'description', title: 'Description', hideInDisplay: true, gridWidth: '3', toolTip: toolTips.options.description },
    { key: 'position', title: 'Position', hideInDisplay: true, gridWidth: '3', type: 'number', toolTip: toolTips.options.position },
    { key: 'integrationPLU', title: 'Integration UID', hideInDisplay: true, gridWidth: '3', toolTip: toolTips.options.integrationPLU },
    { key: 'maxQuantity', title: 'Maximum Quantity', hideInDisplay: true, gridWidth: '3', type: 'number', toolTip: toolTips.options.maxQuantity },
  ],
  optionsForLocationAdmins: [
    { key: 'name', title: 'Name', gridWidth: '3', toolTip: toolTips.options.name, isDisabledForLocationAdmins: true },
    { key: 'priceAddOn', title: 'Price Add On', type: 'decimal', helperText: 'e.g. Enter 2.15 for $2.15', gridWidth: '3', toolTip: toolTips.options.priceAddOn, isDisabledForLocationAdmins: true },
    { key: 'outOfStock', title: 'Out of Stock', type: 'dropdown', allSelectedDisplayValue: 'All Locations', gridWidth: '12', allowMultiple: true, toolTip: toolTips.options.outOfStock },
    { key: 'description', title: 'Description', gridWidth: '3', toolTip: toolTips.options.description, isDisabledForLocationAdmins: true },
  ],
  products: [
    { key: 'name', title: 'Name', gridWidth: '12', isRequired: true, toolTip: toolTips.products.name },
    { key: 'category', title: 'Category', type: 'dropdown', dataTable: 'categories', allowMultiple: false, gridWidth: '12', isRequired: true, toolTip: toolTips.products.category },
    { key: 'locations', title: 'Locations', hideInEdit: true, shouldWrapNewLines: true },
    { key: 'images', title: 'Images', type: 'image', hideInDisplay: true, allowMultiple: false, toolTip: toolTips.products.images },
    { key: 'description', title: 'Description', type: 'longText', gridWidth: '12', hideInDisplay: true, toolTip: toolTips.products.description },
    { key: 'productTax', title: 'Tax', type: 'dropdown', dataTable: 'taxes', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.products.productTax },
    { key: 'position', title: 'Position Ordering', type: 'number', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.products.position },
    { key: 'locations', title: 'Available at Locations', type: 'dropdown', allSelectedDisplayValue: 'All Locations', dataTable: 'locations', hideInDisplay: true, allowMultiple: true, loadSeperately: true, gridWidth: '6', toolTip: toolTips.products.locations },
    { key: 'outOfStock', title: 'Out of Stock', hideInDisplay: false, type: 'dropdown', shouldWrapNewLines: true, allSelectedDisplayValue: 'All Locations', allowMultiple: true, gridWidth: '6', toolTip: toolTips.products.outOfStock },
    { key: 'icons', title: 'Legend', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.products.icons },
    { key: 'widthPercentage', title: 'Width Percentage', type: 'dropdown', hideInDisplay: true, maxWidth: 100, minWidth: 0, helperText: 'e.g. Enter 50 for 50% width', gridWidth: '6', options: widthPercentageDropdownOptions, toolTip: toolTips.products.widthPercentage },
    { key: 'showNote', title: 'Show Note', hideInDisplay: true, type: 'boolean', gridWidth: '6', toolTip: toolTips.products.showNote },
    { key: 'isDisabled', title: 'Disabled', hideInDisplay: false, type: 'boolean', gridWidth: '6', toolTip: toolTips.products.isDisabled },
    { key: 'timeLimits', title: 'Time/Day Limit', gridWidth: '12', toolTip: toolTips.products.timeLimits, hideInDisplay: true, hideInEdit: true },
    { key: 'items', title: 'ITEMS', hideInDisplay: true, gridWidth: '12', toolTip: toolTips.products.items },
    { key: 'component', title: 'Component', type: 'dropdown', dataTable: 'components', hideInDisplay: true, hideInEdit: true, advanced: true, allowMultiple: false, gridWidth: '6', options: componentDropdownOptions, toolTip: toolTips.products.component },
    { key: 'customizationView', title: 'Customization View', type: 'dropdown', options: productsCustomizationViewDropdownOptions, hideInDisplay: true, hideInEdit: true, advanced: true, allowMultiple: false, gridWidth: '6', toolTip: toolTips.products.customizationView },
  ],
  productsForLocationAdmin: [
    { key: 'name', title: 'Name', gridWidth: '12', isRequired: true, toolTip: toolTips.products.name, isDisabledForLocationAdmins: true },
    { key: 'category', title: 'Category', type: 'dropdown', dataTable: 'categories', allowMultiple: false, gridWidth: '12', isRequired: true, toolTip: toolTips.products.category, isDisabledForLocationAdmins: true },
    { key: 'outOfStock', title: 'Out of Stock', hideInDisplay: false, type: 'dropdown', shouldWrapNewLines: true, allSelectedDisplayValue: 'All Locations', allowMultiple: true, gridWidth: '12', toolTip: toolTips.products.outOfStock },
    { key: 'images', title: 'Images', type: 'image', hideInDisplay: true, allowMultiple: false, toolTip: toolTips.products.images, isDisabledForLocationAdmins: true },
  ],
  productsMobileTop: [
    { key: 'name', title: 'Name', gridWidth: '12', isRequired: true, toolTip: toolTips.products.name },
    { key: 'category', title: 'Category', type: 'dropdown', dataTable: 'categories', allowMultiple: false, gridWidth: '12', isRequired: true, toolTip: toolTips.products.category },
    { key: 'locations', title: 'Locations', hideInEdit: true },
    { key: 'images', title: 'Images', type: 'image', hideInDisplay: true, allowMultiple: false, toolTip: toolTips.products.images },
    { key: 'description', title: 'Description', type: 'longText', gridWidth: '12', hideInDisplay: true, toolTip: toolTips.products.description },
    { key: 'productTax', title: 'Tax', type: 'dropdown', dataTable: 'taxes', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.products.productTax },
    { key: 'position', title: 'Position Ordering', type: 'number', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.products.position },
    { key: 'locations', title: 'Available at Locations', type: 'dropdown', dataTable: 'locations', hideInDisplay: true, allowMultiple: true, loadSeperately: true, gridWidth: '6', toolTip: toolTips.products.locations },
    { key: 'outOfStock', title: 'Out of Stock', hideInDisplay: false, type: 'dropdown', allowMultiple: true, gridWidth: '6', toolTip: toolTips.products.outOfStock },
  ],
  productsMobileBottom: [
    { key: 'icons', title: 'Legend', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.products.icons },
    { key: 'widthPercentage', title: 'Width Percentage', type: 'dropdown', hideInDisplay: true, maxWidth: 100, minWidth: 0, helperText: 'e.g. Enter 50 for 50% width', gridWidth: '6', options: widthPercentageDropdownOptions, toolTip: toolTips.products.widthPercentage },
    { key: 'showNote', title: 'Show Note', hideInDisplay: true, type: 'boolean', gridWidth: '6', toolTip: toolTips.products.showNote },
    { key: 'isDisabled', title: 'Disabled', hideInDisplay: false, type: 'boolean', gridWidth: '6', toolTip: toolTips.products.isDisabled },
    { key: 'items', title: 'ITEMS', hideInDisplay: true, gridWidth: '12', toolTip: toolTips.products.items },
    { key: 'component', title: 'Component', type: 'dropdown', dataTable: 'components', hideInDisplay: true, hideInEdit: true, advanced: true, allowMultiple: false, gridWidth: '6', options: componentDropdownOptions, toolTip: toolTips.products.component },
    { key: 'customizationView', title: 'Customization View', type: 'dropdown', options: productsCustomizationViewDropdownOptions, hideInDisplay: true, hideInEdit: true, advanced: true, allowMultiple: false, gridWidth: '6', toolTip: toolTips.products.customizationView },
  ],
  images: [
    { key: 'name', title: 'Name' },
    { key: 'src', title: 'Src', type: 'image' },
  ],
  items: [
    { key: 'name', title: 'Name*', gridWidth: '3', isRequired: true, toolTip: toolTips.items.name },
    { key: 'attribute_name', title: 'Attribute Name*', gridWidth: '3', toolTip: toolTips.items.attribute_name, isRequired: true },
    { key: 'attribute_value', title: 'Attribute Value*', gridWidth: '2', toolTip: toolTips.items.attribute_value, isRequired: true },
    { key: 'price', title: 'Price*', type: 'decimal', helperText: 'e.g. Enter 2.75 for $2.75', gridWidth: '2', isRequired: true, toolTip: toolTips.items.price },
    { key: 'points', title: 'Points', type: 'number', gridWidth: '2', toolTip: toolTips.items.points },
    { key: 'integrationSizeCode', title: 'Size Code', gridWidth: '3', toolTip: toolTips.items.integrationSizeCode },
    { key: 'prepTime', title: 'Prep Time (mins)', helperText: 'e.g. Enter 2 for 2 mins', type: 'number', gridWidth: '3', toolTip: toolTips.items.prepTime },
    { key: 'integrationPLU', title: 'Integration UID', gridWidth: '2', hideInDisplay: true, toolTip: toolTips.items.integrationPLU },
    { key: 'isDefault', title: 'Default*', type: 'boolean', gridWidth: '2', hideInDisplay: true, toolTip: toolTips.items.isDefault, isRequired: true },
    { key: 'isDisabled', title: 'Disabled', type: 'boolean', gridWidth: '2', hideInDisplay: false, toolTip: toolTips.items.isDisabled },
    { key: 'tier', title: 'Tier', type: 'dropdown', dataTable: 'tiers', allowNone: true, gridWidth: '3', toolTip: toolTips.items.tier },
    { key: 'position', title: 'Position', gridWidth: '3', type: 'number', hideInDisplay: true, toolTip: toolTips.items.position },
    { key: 'customizations', title: 'Customizations', type: 'dropdown', dataTable: 'customizations', hideInDisplay: true, allowMultiple: true, loadSeperately: true, viewOnlyName: true, gridWidth: '10', toolTip: toolTips.items.customizations },
    { key: 'includedOptions', title: 'Included Modifier Options', type: 'dropdown', dataTable: 'options', hideInDisplay: true, allowMultiple: true, loadSeperately: true, viewOnlyName: true, gridWidth: '6', toolTip: toolTips.items.includedOptions },
    { key: 'out-of-stock', title: 'Out of Stock Locations', type: 'dropdown', shouldWrapNewLines: true, allSelectedDisplayValue: 'All Locations', gridWidth: '6', hideInDisplay: false, allowMultiple: true },
  ],
  itemsCollapsed: [
    { key: 'name', title: 'Name*', gridWidth: '2', isRequired: true },
    { key: 'attribute_name', title: 'Attribute Name*', gridWidth: '2', isRequired: true },
    { key: 'attribute_value', title: 'Attribute Value*', gridWidth: '2', isRequired: true },
    { key: 'price', title: 'Price*', type: 'decimal', helperText: 'e.g. Enter 2.75 for $2.75', gridWidth: '2', isRequired: true },
    { key: 'position', title: 'Position', gridWidth: '1', type: 'number' },
    { key: 'isDefault', title: 'Default*', gridWidth: '2', type: 'boolean', isRequired: true },
  ],
  collapsibleItemsForLocationAdmins: [
    { key: 'name', title: 'Name*', gridWidth: '2', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'attribute_name', title: 'Attribute Name*', gridWidth: '2', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'attribute_value', title: 'Attribute Value*', gridWidth: '2', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'price', title: 'Price*', type: 'decimal', helperText: 'e.g. Enter 2.75 for $2.75', gridWidth: '2', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'out-of-stock', title: 'Out of Stock Locations', type: 'dropdown', allSelectedDisplayValue: 'All Locations', gridWidth: '6', hideInDisplay: false, allowMultiple: true },
  ],
  editItemsForLocationAdmins: [
    { key: 'name', title: 'Name*', gridWidth: '6', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'out-of-stock', title: 'Out of Stock Locations', type: 'dropdown', allSelectedDisplayValue: 'All Locations', gridWidth: '12', hideInDisplay: false, allowMultiple: true },
    { key: 'attribute_name', title: 'Attribute Name*', gridWidth: '6', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'attribute_value', title: 'Attribute Value*', gridWidth: '12', isDisabledForLocationAdmins: true, isRequired: true },
    { key: 'price', title: 'Price*', type: 'decimal', helperText: 'e.g. Enter 2.75 for $2.75', gridWidth: '6', isDisabledForLocationAdmins: true, isRequired: true },
  ],
  itemsExpanded: [
    { key: 'integrationSizeCode', title: 'Size Code', gridWidth: '2' },
    { key: 'integrationPLU', title: 'Integration UID', gridWidth: '2' },
    { key: 'prepTime', title: 'Prep Time (mins)', helperText: 'e.g. Enter 2 for 2 mins', type: 'number', gridWidth: '2' },
    { key: 'tier', title: 'Tier', type: 'dropdown', dataTable: 'tiers', allowNone: true, gridWidth: '2' },
    { key: 'points', title: 'Points', type: 'number', gridWidth: '1' },
    { key: 'isDisabled', title: 'Disabled', type: 'boolean', gridWidth: '1' },
    { key: 'customizations', title: 'Customizations', type: 'dropdown', dataTable: 'customizations', hideInDisplay: true, allowMultiple: true, loadSeperately: true, viewOnlyName: true, gridWidth: '10' },
    { key: 'includedOptions', title: 'Included Modifier Options', type: 'dropdown', dataTable: 'options', hideInDisplay: true, allowMultiple: true, loadSeperately: true, viewOnlyName: true, gridWidth: '10' },
    { key: 'out-of-stock', title: 'Out of Stock Locations', type: 'dropdown', allSelectedDisplayValue: 'All Locations', gridWidth: '6', hideInDisplay: false, allowMultiple: true },
  ],
  categories: [
    { key: 'name', title: 'Name', gridWidth: '6', isRequired: true, toolTip: toolTips.categories.name },
    { key: 'categoryTax', title: 'Tax', type: 'dropdown', dataTable: 'taxes', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.categories.categoryTax },
    { key: 'widthPercentage', title: 'Width Percentage', type: 'dropdown', hideInDisplay: true, maxWidth: 100, minWidth: 0, helperText: 'e.g. Enter 50 for 50% width', gridWidth: '6', options: widthPercentageDropdownOptions, toolTip: toolTips.categories.widthPercentage },
    { key: 'position', title: 'Position Ordering', type: 'number', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.categories.position },
    { key: 'image', title: 'Image', type: 'image', hideInDisplay: true, allowMultiple: false, toolTIp: toolTips.categories.image },
    { key: 'prepTime', title: 'Prep Time', type: 'number', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.categories.prepTime },
    { key: 'quantityThreshold', title: 'Quantity Threshold', type: 'number', hideInDisplay: true, gridWidth: '6', toolTip: toolTips.categories.quantityThreshold },
    { key: 'orderTypes', title: 'Order Types', type: 'dropdown', allowMultiple: true, hideInDisplay: true, gridWidth: '12', toolTip: toolTips.categories.orderTypes },
    { key: 'description', title: 'Description', type: 'longText', hideInDisplay: true, gridWidth: '12', toolTip: toolTips.categories.description },
    { key: 'timeLimits', title: 'Time/Day Limit', gridWidth: '12', shouldWrapNewLines: true, toolTip: toolTips.categories.timeLimits },
    { key: 'isDisabled', title: 'Disabled', type: 'boolean', gridWidth: '12', toolTip: toolTips.categories.categories },
  ],
  users: [
    { key: 'name', title: 'Name', gridWidth: '6', toolTip: toolTips.users.name },
    { key: 'email', title: 'Email', gridWidth: '6', toolTip: toolTips.users.email },
    { key: 'telephone', title: 'Phone', gridWidth: '6', toolTip: toolTips.users.telephone },
    // Show these once we have balance and point calculation integrated
    { key: 'points', title: 'Points', gridWidth: '6', type: 'number', toolTip: toolTips.users.points },
    // { key: 'addresses', title: 'Addresses', hideInEdit: true, toolTip: toolTips.users.addresses },
    // { key: 'balance', title: 'Balance' }
    { key: 'lastOrder', title: 'Last Order', gridWidth: '9', toolTip: toolTips.users.lastOrder },
  ],
  addresses: [
    { key: 'nickname', title: 'Nickname', gridWidth: '6', toolTip: toolTips.addresses.nickname },
    { key: 'buzzer_number', title: 'Buzzer Number', gridWidth: '6', toolTip: toolTips.addresses.buzzer_number },
    { key: 'street_address', title: 'Street Address', gridWidth: '6', toolTip: toolTips.addresses.street_address },
    { key: 'unit_number', title: 'Unit Number', gridWidth: '6', toolTip: toolTips.addresses.unit_number },
    { key: 'city', title: 'City', gridWidth: '6', toolTip: toolTips.addresses.city },
    { key: 'province', title: 'Province', gridWidth: '6', toolTip: toolTips.addresses.province },
    { key: 'postal_code', title: 'Postal Code', gridWidth: '6', toolTip: toolTips.addresses.postal_code },
    { key: 'country', title: 'Country', gridWidth: '6', toolTip: toolTips.addresses.country },
    { key: 'comments', title: 'Comments', gridWidth: '6', toolTip: toolTips.addresses.comments },
  ],
  zones: [
    { key: 'name', title: 'Name', gridWidth: '4', isRequired: true, toolTip: toolTips.zones.name },
    { key: 'fee', title: 'Fee', type: 'decimal', gridWidth: '4', toolTip: toolTips.zones.fee },
    { key: 'minimum', title: 'Minimum Orders', type: 'decimal', gridWidth: '4', toolTip: toolTips.zones.minimum },
    { key: 'belowMinimumFee', title: 'Below Minimum Fee', type: 'decimal', gridWidth: '4', toolTip: toolTips.zones.below_minimum_fee },
    { key: 'coordinates', title: 'Coordinates', type: 'longText', gridWidth: '12', isRequired: true, toolTip: toolTips.zones.coordinates },
  ],
  'catering-zones': [
    { key: 'name', title: 'Name', gridWidth: '4', isRequired: true, toolTip: toolTips['catering-zones'].name },
    { key: 'fee', title: 'Fee', type: 'decimal', gridWidth: '4', toolTip: toolTips.zones.fee },
    { key: 'minimum', title: 'Minimum Orders', type: 'number', gridWidth: '4', toolTip: toolTips.zones.minimum },
    { key: 'belowMinimumFee', title: 'Below Minimum Fee', type: 'decimal', gridWidth: '4', toolTip: toolTips.zones.below_minimum_fee },
    { key: 'coordinates', title: 'Coordinates', type: 'longText', gridWidth: '12', isRequired: true, toolTip: toolTips.zones.coordinates },
  ],
  orders: [
    { key: 'id', title: '#', gridWidth: '6', hideInEdit: true, toolTip: toolTips.orders.id },
    { key: 'desiredTime', title: 'DESIRED TIME', gridWidth: '6', hideInEdit: true, toolTip: toolTips.orders.desiredTime },
    { key: 'user', title: 'CUSTOMER', gridWidth: '6', hideInEdit: true, toolTip: toolTips.orders.user },
    { key: 'telephone', title: 'PHONE', gridWidth: '9', hideInEdit: true, hideInDisplay: false, toolTip: toolTips.orders.telephone },
    { key: 'items', title: 'ORDER DETAIL', gridWidth: '9', hideInEdit: true, type: 'longText', boxHeight: 150, toolTip: toolTips.orders.items },
    { key: 'deliveryOption', title: 'TYPE', gridWidth: '4', hideInEdit: true, toolTip: toolTips.orders.deliveryOption },
    { key: 'address', title: 'ADDRESS', hideInDisplay: false, gridWidth: '12', hideInEdit: true, toolTip: toolTips.orders.address },
    { key: 'totalPrice', title: 'TOTAL PRICE', gridWidth: '6', hideInEdit: true, hideInDisplay: true, hideInView: true, toolTip: toolTips.orders.totalPrice },
    { key: 'tipAmount', title: 'TIPS', gridWidth: '4', hideInEdit: true, hideInDisplay: true, hideInView: true, toolTip: toolTips.orders.tipAmount },
    { key: 'tax', title: 'TAX', gridWidth: '4', hideInEdit: true, hideInDisplay: true, hideInView: true, toolTip: toolTips.orders.tax },
    { key: 'isASAP', title: 'ASAP', type: 'boolean', gridWidth: '6', hideInEdit: true, hideInDisplay: true, toolTip: toolTips.orders.isASAP },
    { key: 'orderStatus', title: 'STATUS', gridWidth: '3', type: 'dropdown', options: orderStatusDropdownOptions, hideInEdit: false, toolTip: toolTips.orders.orderStatus },
  ],
  orderItems: [
    { key: 'quantity', title: 'Quantity', gridWidth: '1' },
    { key: 'productItem', title: 'Product Item', type: 'nameOnly', gridWidth: '2' },
    { key: 'options', title: 'Options', type: 'viewListWithQuantity', gridWidth: '4', shouldWrapNewLines: true },
    { key: 'note', title: 'Item Instructions', gridWidth: '2' },
    { key: 'totalRedeemedAmount', title: 'Total Redeemed Amount', gridWidth: '1' },
    { key: 'totalPrice', title: 'Total Price', type: 'number', gridWidth: '1' },
  ],
  // For viewing Orders,
  // these fields can use `paths` for accessing nested values returned by the API for orders.
  // If `path` is not defined,
  // this means the `key` will give you the value at the top level of an order object.
  // If the API does not return a value for a field,
  // the entire field normally will not show, unless you define `emptyValue`,
  // which will make the field's title show with that value.
  // The commented out fields are those we don't show,
  // but they are here as a record for how to access their value when
  // the API returns it.
  orderItemsCustomerInformation: [
    { key: 'name', title: 'Name', gridWidth: '6', path: 'user.name', emptyValue: 'N/A' },
    { key: 'phone', title: 'Phone Number', gridWidth: '6', path: 'user.telephone', emptyValue: 'N/A' },
    { key: 'address', title: 'Address', gridWidth: '6', path: 'address', emptyValue: 'N/A' },
    { key: 'deliveryOption', title: 'Delivery Option', gridWidth: '6', emptyValue: 'N/A' },
    { key: 'tableNumber', title: 'Table Number', gridWidth: '6' },
    { key: 'isCurbsidePickUp', title: 'Curbside Pickup', gridWidth: '6' },
    { key: 'vehicleInformation', title: 'Vehicle Information', gridWidth: '6' },
    { key: 'isASAP', title: 'ASAP', gridWidth: '6', path: 'isASAP', emptyValue: 'N/A' },
    { key: 'desiredTime', title: 'Desired Time', gridWidth: '6', path: 'desiredTime', emptyValue: 'N/A' },
    // { key: 'deliveryId', title: 'Delivery ID', gridWidth: '6' },
    // { key: 'quoteId', title: 'Postmates Delivery Quote ID', gridWidth: '6' },
    // { key: 'externalOrderId', title: 'External Order ID', gridWidth: '6' },
    // { key: 'externalFulfillmentId', title: 'External Fulfillment ID', gridWidth: '6' },
  ],
  orderItemsOrderDetails: [
    { key: 'orderStatus', title: 'Order Status', gridWidth: '6' },
    { key: 'orderId', title: 'Order #', gridWidth: '6', path: 'id' },
    { key: 'orderDate', title: 'Order Date/Time', gridWidth: '6', path: 'placedAt' },
    { key: 'orderInstructions', title: 'Order Instructions', gridWidth: '6', path: 'note', emptyValue: 'N/A' },
    { key: 'deliveryTrackingUrl', title: 'Delivery Tracking URL', gridWidth: '6' },
    { key: 'fulfillmentLocation', title: 'Location Received', gridWidth: '6', path: 'location.address' },
    { key: 'calculatedServiceFees', title: 'Service Fee', gridWidth: '6' },
  ],
  orderItemsBottomSection: [
    { key: 'subtotal', title: 'Subtotal', gridWidth: '6', path: 'price', emptyValue: 'N/A' },
    { key: 'tax', title: 'Tax', gridWidth: '6', path: 'tax', emptyValue: 'N/A' },
    { key: 'calculatedServiceFees', title: 'Service Fee', gridWidth: '6' },
    { key: 'tipAmount', title: 'Tip', gridWidth: '6', path: 'tipAmount', emptyValue: 'N/A' },
    { key: 'deliveryTip', title: 'Delivery Tip', gridWidth: '6', path: 'deliveryTip' },
    { key: 'totalTip', title: 'Total Tip', gridWidth: '6', path: 'totalTip', emptyValue: 'N/A' },
    { key: 'deliveryFee', title: 'Delivery Fee', gridWidth: '6', path: 'deliveryFee' },
    { key: 'cateringFee', title: 'Catering Fee', gridWidth: '6' },
    // { key: 'externalDeliveryFee', title: 'External Delivery Fee', gridWidth: '6' },
    // { key: 'serviceChargeAmount', title: 'Service Charge Amount', gridWidth: '6' },
    { key: 'coupons', title: 'Coupons', gridWidth: '6', path: 'coupons' },
    { key: 'couponValue', title: 'Coupon/Discount Value', gridWidth: '6', path: 'couponValue' },
    { key: 'totalPrice', title: 'Grand Total', gridWidth: '6', emptyValue: 'N/A' },
    { key: 'paymentType', title: 'Payment Type', gridWidth: '6', path: 'transaction.paymentType' },
    { key: 'transactionAmount', title: 'Amount Paid', gridWidth: '6', path: 'transaction.amount' },
    { key: 'transactionStatus', title: 'Transaction Status', gridWidth: '6', path: 'transaction.transactionStatus' },
    { key: 'transactionTimestamp', title: 'Transaction Date/Time', gridWidth: '6', path: 'transaction.timestamp.epochSecond' },
    { key: 'transactionReference', title: 'Reference ID', gridWidth: '6', path: 'transaction.reference' },
  ],
  reports: [
    { key: 'type', title: 'Type', gridWidth: '1' },
    { key: 'dateRange', title: 'Date Range', type: 'dateRange', gridWidth: '8' },
    { key: 'downloadCsvButton', gridWidth: '2' },
  ],
  taxes: [
    { key: 'name', title: 'Name', gridWidth: '6', isRequired: true, toolTip: toolTips.taxes.name },
    { key: 'percentage', title: 'Percentage', type: 'allDecimalsAllowed', gridWidth: '6', isRequired: true, toolTip: toolTips.taxes.percentage },
    { key: 'disabled', title: 'Disable', gridWidth: '6', isRequired: false },
  ],
  components: [
    { key: 'product', id: 1, name: 'Product', value: 'PRODUCT' },
    { key: 'halfAndHalf', id: 2, name: 'Half and half', value: 'HALF_AND_HALF' },
    { key: 'createYourOwn', id: 3, name: 'Create your own', value: 'CREATE_YOUR_OWN' },
  ],
  companies: [
    { key: 'name', title: 'Name', gridWidth: '6' },
    { key: 'mailgunApiKey', title: 'Mailgun Api Key', gridWidth: '6' },
    { key: 'mailgunFromEmail', title: 'Mailgun From Email', gridWidth: '6' },
    { key: 'mailgunDomain', title: 'Mailgun Domain', gridWidth: '6' },
    { key: 'paymentIntegration', title: 'Payment Integration', type: 'dropdown', gridWidth: '6' },
    { key: 'paymentIntegrationCredentials', title: 'Payment Integration Credentials', hideInDisplay: true, gridWidth: '6' },
    { key: 'posIntegration', title: 'Pos Integration', type: 'dropdown', gridWidth: '6' },
    { key: 'posIntegrationCredentials', title: 'Pos Integration Credentials', hideInDisplay: true, gridWidth: '6' },
    { key: 'welcomeEmailSubject', title: 'Welcome Email Subject', hideInDisplay: true, gridWidth: '4' },
    { key: 'forgotPassEmailSubject', title: 'Retrieve Password Email Subject', hideInDisplay: true, gridWidth: '4' },
    { key: 'orderInfoEmailSubject', title: 'Order Info Email Subject', hideInDisplay: true, gridWidth: '4' },
    { key: 'welcomeEmailBody', title: 'Welcome Email Body', hideInDisplay: true, isHtmlFormat: true, gridWidth: '4' },
    { key: 'forgotPassEmailBody', title: 'Retrieve Password Email Body', hideInDisplay: true, isHtmlFormat: true, gridWidth: '4' },
    { key: 'orderInfoEmailBody', title: 'Order Info Email Body', hideInDisplay: true, isHtmlFormat: true, gridWidth: '4' },
    { key: 'featureImages', title: 'Feature Images', type: 'image', allowMultiple: true, hideInDisplay: true, gridWidth: '4' },
  ],
  posIntegration: [
    { key: 'none', id: 0, name: 'None', value: 'NONE' },
    { key: 'speedLine', id: 1, name: 'SpeedLine', value: 'SPEEDLINE' },
    { key: 'speedlineC', id: 2, name: 'SpeedLine_c', value: 'SPEEDLINE_C' },
    { key: 'revel', id: 3, name: 'Revel', value: 'REVEL' },
    { key: 'square', id: 4, name: 'Square', value: 'SQUARE' },
    { key: 'auphan', id: 5, name: 'Auphan', value: 'AUPHAN' },
    { key: 'orderlord', id: 6, name: 'OrderLord', value: 'ORDERLORD' },
    { key: 'clover', id: 7, name: 'Clover', value: 'CLOVER' },
  ],
  paymentIntegration: [
    { key: 'none', id: 0, name: 'None', value: 'NONE' },
    { key: 'moneris', id: 1, name: 'Moneris', value: 'MONERIS' },
    { key: 'stripe', id: 2, name: 'Stripe', value: 'STRIPE' },
    { key: 'revelx', id: 3, name: 'Realex', value: 'REALEX' },
    { key: 'vantiv', id: 4, name: 'Vantiv', value: 'VANTIV' },
    { key: 'square', id: 5, name: 'Square', value: 'SQUARE' },
    { key: 'usaEpay', id: 6, name: 'USA_Epay', value: 'USA_EPAY' },
    { key: 'stripeConnect', id: 7, name: 'Stripe_Connect', value: 'STRIPE_CONNECT' },
  ],
  tiers: [
    { key: 'points', title: 'Points', gridWidth: '6', isRequired: true, type: 'number', toolTip: toolTips.tiers.points },
    { key: 'name', title: 'Name', gridWidth: '6', isRequired: true, toolTip: toolTips.tiers.name },
    { key: 'productItems', title: 'Attached Items', type: 'searchable', gridWidth: '12', shouldWrapNewLines: true },
    { key: 'description', title: 'Description', gridWidth: '12', isRequired: false, toolTip: toolTips.tiers.description },
    { key: 'image', title: 'Image', type: 'image', hideInDisplay: true, allowMultiple: false, isRequired: false, toolTip: toolTips.tiers.image },
    { key: 'rewardType', title: 'Reward Type', type: 'dropdown', allowMultiple: false, gridWidth: '6', isRequired: true, toolTip: toolTips.tiers.rewardType },
    { key: 'dollarAmount', title: 'Dollar Amount', type: 'decimal', gridWidth: '6', isRequired: true, toolTip: toolTips.tiers.dollarAmount },
  ],
  coupons: [
    { key: 'code', title: 'Code', gridWidth: '6', isRequired: true, toolTip: toolTips.coupons.code },
    { key: 'title', title: 'Title', gridWidth: '6', toolTip: toolTips.coupons.title },
    { key: 'description', title: 'Description', type: 'longText', hideInDisplay: true, gridWidth: '12', toolTip: toolTips.coupons.description },
    { key: 'actionType', title: 'Type', type: 'dropdown', gridWidth: '6', isRequired: true, toolTip: toolTips.coupons.actionType },
    { key: 'actionValue', title: 'Discount Amount', type: 'decimal', gridWidth: '6', isRequired: true, toolTip: toolTips.coupons.actionValue },
    { key: 'exclusive', title: 'Exclusive', type: 'boolean', gridWidth: '3', toolTip: toolTips.coupons.exclusive },
    { key: 'autoApply', title: 'Auto Apply', type: 'boolean', gridWidth: '6', toolTip: toolTips.coupons.autoApply },
  ],
  restrictions: [
    { key: 'type', title: 'Type', type: 'dropdown', gridWidth: '6', isRequired: true },
    { key: 'value', title: 'Value', gridWidth: '6', isRequired: true },
  ],
};

export const reportsPageTableRows = [
  { type: 'Sales Report', reportType: 'sales' },
  { type: 'Inventory Report', reportType: 'inventory' },
  { type: 'Customer Data', reportType: 'userData' },
];

export const restrictionTypeIndex = resourceFields.restrictions.findIndex(elem => elem.key === 'type');
export const restrictionValueIndex = resourceFields.restrictions.findIndex(elem => elem.key === 'value');
export const hoursIndex = resourceFields.locations.findIndex(elem => elem.key === 'hours');
export const squareIdIndex = resourceFields.locations.findIndex(elem => elem.key === 'squareId');
export const deliveryTimeIndex = resourceFields.locations.findIndex(elem => elem.key === 'deliveryTime');
export const pickupTimeIndex = resourceFields.locations.findIndex(elem => elem.key === 'pickupTime');
export const timeLimitsIndex = resourceFields.categories.findIndex(elem => elem.key === 'timeLimits');
export const squareIdLettersAndNumbersOnly = /^[A-Za-z0-9]+$/;

export const fieldIndexes = {
  items: {
    name: resourceFields.items.findIndex(elem => elem.key === 'name'),
    attribute_value: resourceFields.items.findIndex(elem => elem.key === 'attribute_value'),
    attribute_name: resourceFields.items.findIndex(elem => elem.key === 'attribute_name'),
    price: resourceFields.items.findIndex(elem => elem.key === 'price'),
    isDefault: resourceFields.items.findIndex(elem => elem.key === 'isDefault'),
  },
};

export const kmlButtonTitles = [
  'kml',
  'catering-zones-kml',
];

export const variationFields = [
  'attribute_name',
  'attribute_value',
  'price',
  'isDefault',
];

export const itemValidationFields = [
  'attribute_name',
  'name',
  'attribute_value',
  'price',
  'isDefault',
];

export const productIcons = [
  { key: 'vegetarian', title: 'Vegetarian' },
  { key: 'gluten-free', title: 'Gluten-Free' },
  { key: 'vegan', title: 'Vegan' },
];

export const sevenDaysInAWeek = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
};

export const SEVEN_DAYS_IN_WEEK = Object.keys(sevenDaysInAWeek);

// Todo: limited color size, better to generate dynamically

export const craverColors = ['#EF3924', '#F16122', '#FDB614'];
// static for now without login for admins
// in the future we'll need to update this dynamically
export const companyHeader = { 'Content-Type': 'application/json', Authorization: 'Bearer f572bbbe-5104-4ed7-8934-afdd8a5e3d62' };

export const productPaginationCount = 1000;
export const orderPaginationCount = 10;
export const locationPaginationCount = 30;
export const userPaginationCount = 100;
export const optionPaginationCount = 1000;
export const paginationStart = 0;

export const editorApiKey = '5eptpqx17h0b2ikp0vxnfhab27zdzcombobni69e59sqpo6i';

export const days = [
  { key: 'SUNDAY', title: 'Su' },
  { key: 'MONDAY', title: 'Mo' },
  { key: 'TUESDAY', title: 'Tu' },
  { key: 'WEDNESDAY', title: 'We' },
  { key: 'THURSDAY', title: 'Th' },
  { key: 'FRIDAY', title: 'Fr' },
  { key: 'SATURDAY', title: 'Sa' },
];

export const itemCustomizationFields = [
  { key: 'minOptions', title: 'Min Selectable', type: 'number', gridWidth: '2', disabled: true },
  { key: 'maxOptions', title: 'Max Selectable', type: 'number', gridWidth: '2', disabled: true },
  { key: 'position', title: 'Order', type: 'number', gridWidth: '2', disabled: true },
  { key: 'isMandatory', title: 'Mandatory', type: 'boolean', gridWidth: '3', disabled: true },
  { key: 'freeOptions', title: 'Free', type: 'number', gridWidth: '2' },
];

export const orderTypes = [
  { key: 'pickup', name: 'Pick Up', id: 1, value: 'PICKUP' },
  { key: 'delivery', name: 'Delivery', id: 2, value: 'DELIVERY' },
  { key: 'dineIn', name: 'Dine In', id: 3, value: 'DINE_IN' },
  { key: 'catering', name: 'Catering', id: 4, value: 'CATERING' },
];

export const notificationsOrderType = [
  { name: 'Pick Up', value: 'PICKUP', id: 1 },
  { name: 'Delivery', value: 'DELIVERY', id: 2 },
  { name: 'All', value: 'ALL', id: 3 },
];

export const timeLines = [
  { label: 'All', value: 0 },
  { label: '1 Week', value: 604800 },
  { label: '2 Weeks', value: 1209600 },
  { label: '30 days', value: 2592000 },
  { label: '60 days', value: 5184000 },
  { label: '90 days', value: 7776000 },
];

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const currencyCodes = [
  { name: 'CAD', value: 'CAD', id: 1 },
  { name: 'USD', value: 'USD', id: 2 },
  { name: 'AUD', value: 'AUD', id: 3 },
  { name: 'GBP', value: 'GBP', id: 4 },
];

export const payAtDoorOptionsList = [
  { name: 'Cash', value: 'CASH', id: 1 },
  { name: 'Debit', value: 'DEBIT', id: 2 },
  { name: 'Credit', value: 'CREDIT', id: 3 },
];

export const reportFrequency = [
  { name: 'None', value: 'NONE', id: 1 },
  { name: 'Daily', value: 'DAILY', id: 2 },
  { name: 'Weekly', value: 'WEEKLY', id: 3 },
  { name: 'Monthly', value: 'MONTHLY', id: 4 },
];

export const couponActionTypes = [
  { name: 'Dollar', value: 'DOLLAR', id: 1 },
  { name: 'Percent', value: 'PERCENT', id: 2 },
];

export const tiersRewardType = [
  { name: 'Item', value: 'ITEM', id: 1 },
  { name: 'Dollar', value: 'DOLLAR', id: 2 },
];

export const restricitionTypes = [
  { name: 'Per User', value: 'PER_USER', id: 1, type: 'number' },
  { name: 'Start DateTime', value: 'START_DATETIME', id: 2, type: 'datetime' },
  { name: 'End DateTime', value: 'END_DATETIME', id: 3, type: 'datetime' },
  { name: 'Start Time of Day', value: 'START_TIME_OF_DAY', id: 4, type: 'time' },
  { name: 'End Time of Day', value: 'END_TIME_OF_DAY', id: 5, type: 'time' },
  { name: 'Days of Week', value: 'DAYS_OF_WEEK', id: 6, type: 'dropdown', allowMultiple: true },
  { name: 'Min Purchase', value: 'MIN_PURCHASE', id: 7, type: 'decimal' },
  { name: 'Min Purchase After Coupon', value: 'MIN_PURCHASE_AFTER_COUPON', id: 8, type: 'decimal' },
  { name: 'Delivery Type', value: 'DELIVERY_TYPE', id: 9, type: 'dropdown', allowMultiple: true },
  { name: 'First Order Of Customer', value: 'FIRST_ORDER_OF_CUSTOMER', id: 10, type: 'boolean' },
  // This is to be ignored for the moment
  // { name: 'Items Count Devided By', value: 'ITEMS_COUNT_DEVIDED_BY', id: 10, type: 'number' },
  { name: 'Max Items Count', value: 'MAX_ITEMS_COUNT', id: 11, type: 'number' },
  { name: 'Category', value: 'CATEGORY', id: 12, type: 'searchable' },
  { name: 'Product', value: 'PRODUCT', id: 13, type: 'searchable' },
  { name: 'Product Item', value: 'PRODUCT_ITEM', id: 14, type: 'searchable' },
  { name: 'Exclude Category', value: 'EXCLUDE_CATEGORY', id: 15, type: 'searchable' },
  { name: 'Exclude Product', value: 'EXCLUDE_PRODUCT', id: 16, type: 'searchable' },
  { name: 'Exclude Product Item', value: 'EXCLUDE_PRODUCT_ITEM', id: 17, type: 'searchable' },
  { name: 'Apply To Each Item', value: 'APPLY_TO_EACH_ITEM', id: 18, type: 'boolean' },
  { name: 'Location', value: 'LOCATIONS', id: 19, type: 'searchable' },
  { name: 'Users', value: 'USERS', id: 20, type: 'searchable' },
];

export const daysOfWeek = [
  { name: 'Sunday', value: 'SUNDAY', id: 1 },
  { name: 'Monday', value: 'MONDAY', id: 2 },
  { name: 'Tuesday', value: 'TUESDAY', id: 3 },
  { name: 'Wednesday', value: 'WEDNESDAY', id: 4 },
  { name: 'Thursday', value: 'THURSDAY', id: 5 },
  { name: 'Friday', value: 'FRIDAY', id: 6 },
  { name: 'Saturday', value: 'SATURDAY', id: 7 },
];

export const deliveryType = [
  { name: 'Pickup', value: 'PICKUP', id: 1 },
  { name: 'Delivery', value: 'DELIVERY', id: 2 },
  { name: 'Dine In', value: 'DINE_IN', id: 3 },
  { name: 'Catering', value: 'CATERING', id: 4 },
];

export const pieChartLegend = {
  display: false,
};

export const lineChartOptions = {
  scales: {
    yAxes: [{
      ticks: {
        // use max and min to set the range of y-axis
        // max: 100,
        // min: 0,
        stepSize: 1,
      },
    }],
  },
};

export const predefinedFieldTypes = ['image', 'hours', 'dropdown', 'boolean']; // to avoid unknown props passed down to textfield}

export const valueKeys = [
  'component',
  'customizationView',
  'posIntegration',
  'paymentIntegration',
  'currencyCode',
  'reportFrequency',
  'actionType',
  'type',
  'widthPercentage',
  'orderStatus',
  'rewardType',
];

export const productFields = [
  'category',
  'component',
  'customizationView',
  'description',
  'icons',
  'images',
  'isDisabled',
  'locations',
  'name',
  'position',
  'widthPercentage',
];

export const defaultCustomizationFields = [
  'description', 'id', 'isMandatory', 'isSingleSelectDefault',
  'key', 'maxOptions', 'minOptions', 'name',
  'position', 'title', 'useLeftRightOptions'];

export const deliveryOptionIconName = {
  PICKUP: 'local_mall',
  DELIVERY: 'directions_bike',
  DINE_IN: 'restaurant_menu',
  CATERING: 'room_service',
};

export const orderStatusColors = {
  NEW: '#f2b02a',
  PAYMENT_PENDING: '#f3a02a',
  RECEIVED: '#f16122',
  PROCESSED: '#4a90e2',
  READY: '#6fbb1c',
  COMPLETED: '#000',
  CANCELED: '#9b9b9b',
};

export const outOfStockBooleanVersion = {
  key: 'outOfStock',
  title: 'Out of Stock',
  hideInDisplay: false,
  type: 'boolean',
  gridWidth: '4',
  toolTip: toolTips.products.outOfStock,
};

export const allAccessAdmin = {
  id: 6,
  email: 'craverDemo@admin.com',
};

export const validationErrorMessages = {
  items: {
    name: 'Name cannot be blank.',
    attribute_name: 'Attribute Name cannot be blank',
    attribute_value: 'Attribute Value cannot be blank',
    isDefault: 'You must select whether or not this item is the default.',
    price: 'Please enter price between 0 and $999.99',
  },
  field: {
    isRequiredError: 'Please enter a value',
    invalidDecimalError: 'should only have two digits after points',
  }
};

export const menuBarSubMenus = {
  Menu: [
    { key: 'Full Menu', path: '/menu', val: 1, selectedTest: /products|menu/ },
    { key: 'Categories', path: '/categories', val: 0, selectedTest: /categories/ },
    { key: 'Items', path: '/items', val: 4, selectedTest: /items/ },
    { key: 'Modifier Groups', path: '/customizations', val: 2, selectedTest: /customizations/ },
    { key: 'Modifier Options', path: '/options', val: 3, selectedTest: /options/ },
    { key: 'Taxes', path: '/taxes', val: 5, selectedTest: /taxes/ },
  ],
};

export const deliveryServices = [
  'DOORDASH',
  'POSTMATES',
];

export const smallTables = [
  'customizations',
  'taxes',
  'categories',
];

export const deliveryAndCateringZonesButtonArray = [
  { id: 1, btnTitle: 'zones' },
  { id: 2, btnTitle: 'catering-zones' },
  { id: 3, btnTitle: 'kml' },
  { id: 4, btnTitle: 'catering-zones-kml' },
];

export const locationsMenuConstant = {
  ADD: 'add',
  VIEW: 'view',
  ZONES: 'zones',
  CATERING_ZONES: 'catering-zones',
  KML: 'kml',
  KML_TYPE: 'file',
  KML_EXTENSION: '.kml',
  LOCATIONS: 'locations',
  CONFIRM_UPLOAD_DELIVERY_KML: `Create and/or update Delivery zones with the layer names and coordinates in your kml file`,
  CONFIRM_UPLOAD_CATERING_KML: `Create and/or update Catering zones with the layer names and coordinates in your kml file`,
}

export const bulkActionResourceNames = ['products', 'categories', 'options'];

export const needsRemoveIntegrationPluBeforeDuplicate = ['categories', 'products', 'items', 'taxes', 'customizations', 'options'];

export const ordersFilterFields = [
  { key: 'deliveryOption' },
  { key: 'orderStatus' },
];

export const orderFiltersTitles = {
  orderStatus: 'STATUS',
  deliveryOption: 'ORDER TYPE',
};

const orderFiltersDeliveryOptions = cloneDeep(orderTypes);

const orderStatusOptionsNewRemoved = orderStatusDropdownOptions.map((option, ind) => {
  if (option.name === 'NEW') return null;
  const optionClone = cloneDeep(option);
  optionClone.id = ind + 1;
  return optionClone;
});
const orderStatusOptionsForOrdersList = compact(orderStatusOptionsNewRemoved);

export const orderFiltersDropdownOptions = {
  orderStatus: orderStatusOptionsForOrdersList,
  deliveryOption: orderFiltersDeliveryOptions,
  orderType: orderFiltersDeliveryOptions,
};

export const searchableItemsResources = ['tiers', 'customizations'];

export const rewardTypes = Object.freeze({
  DOLLAR: 'DOLLAR',
  PERCENT: 'PERCENT',
});

export const bulkActions = {
  disable: {
    title: 'Disable',
    uri: 'disable',
    allowedPages: ['products', 'categories'],
    dialogTitle: 'Disable #RESOURCE#',
    dialogConfirmText: 'Are you sure you want to disable the #RESOURCE# below?',
    dialogBtnText: 'Yes, Disable #RESOURCE#',
    isUsableByLocationAdmins: false,
  },
  enable: {
    title: 'Enable',
    uri: 'enable',
    allowedPages: ['products', 'categories'],
    dialogTitle: 'Enable #RESOURCE#',
    dialogConfirmText: 'Are you sure you want to enable the #RESOURCE# below?',
    dialogBtnText: 'Yes, Enable #RESOURCE#',
    isUsableByLocationAdmins: false,
  },
  outOfStock: {
    title: 'Out of Stock',
    uri: 'bulk-out-of-stock',
    dialogTitle: 'Mark #RESOURCE# as Out of Stock',
    dialogSlectText: 'Please select the locations that are out of stock',
    dialogConfirmText: 'Are you sure you want to mark the below #RESOURCE# as out of stock?',
    dialogBtnText: 'Yes, Mark as Out of Stock',
    allowedPages: ['products', 'options'],
    isUsableByLocationAdmins: true,
  },
  inStock: {
    title: 'In Stock',
    uri: 'bulk-out-of-stock',
    dialogTitle: 'Mark #RESOURCE# as In Stock',
    dialogSlectText: 'Please select the locations that are in stock',
    dialogConfirmText: 'Are you sure you want to mark the below #RESOURCE# as in stock?',
    dialogBtnText: 'Yes, Mark as In Stock',
    allowedPages: ['products', 'options'],
    isUsableByLocationAdmins: true,
  },
  delete: {
    title: 'Delete',
    allowedPages: ['options'],
    dialogTitle: 'Delete #RESOURCE#',
    dialogConfirmText: 'Are you sure you want to delete the #RESOURCE# below?',
    dialogBtnText: 'Yes, Delete #RESOURCE#',
    isUsableByLocationAdmins: false,
  },
};

const taxDisableAction = {
  disable: {
    title: 'Disable',
    uri: 'disable',
    allowedPages: ['taxes'],
    dialogConfirmText: 'Confirm that you want to disable this tax. This tax will not be deleted and all your customizations will be saved if you choose to enable this tax in the future.',
    isUsableByLocationAdmins: false,
  },
};

const taxEnableAction = {
  enable: {
    title: 'Enable',
    uri: 'enable',
    allowedPages: ['taxes'],
    dialogConfirmText: 'Confirm that you want to enable this tax.',
    isUsableByLocationAdmins: false,
  },
};

const taxDeleteAction = {
  delete: {
    title: 'Delete',
    uri: 'delete',
    allowedPages: ['taxes'],
    dialogConfirmText: 'Confirm that you want to delete this tax and remove it from your admin panel. You will have to re-create the tax if you need it in the future. There is the option to DISABLE the tax instead, which preserves your settings.',
    isUsableByLocationAdmins: false,
  },
};

export const taxActions = {
  ...taxDisableAction,
  ...taxEnableAction,
  ...taxDeleteAction,
};

export const taxActionsEnabled = {
  ...taxDisableAction,
  ...taxDeleteAction,
};

export const taxActionsDisabled = {
  ...taxEnableAction,
  ...taxDeleteAction,
};

export const taxesTextConstants = {
  taxDetailsSubtitle: 'Create the tax type creating the tax name and a percentage value.',
  taxLocationsSubtitle: 'By default, this tax will be applied to all the categories and products for all selected locations. Taxes may also be set to specific categories and/or products.',
};

export const resourceDisplayNameMap = {
  products: 'items',
  items: 'variations',
  customizations: 'modifier groups',
  options: 'modifier options',
};

export const YES_ONLY_COUPON_RESTRICTIONS = ['FIRST_ORDER_OF_CUSTOMER', 'APPLY_TO_EACH_ITEM'];
export const NOTIFICATION_TITLE_MAX_LENGTH = 50;
export const NOTIFICATION_BODY_MAX_LENGTH = 178;
export const fieldsWithSelectAllOption = {
  outOfStock: true,
  'out-of-stock': true,
  locations: true,
};
export const MAX_CHAR_TABLE_FIELD = 150;
export const MAX_CHAR_DESCRIBE_TEXTFIELD = 600;
export const TAX_NAME_MAX_LENGTH = 255;
export const LONG_TEXT_FIELD_HEIGHT = 4;
export const MAX_CHAR_DESCRIPTION_RESOURCES = ['categories', 'products'];
export const TAXES_HELP_TEXT = 'Create or edit taxes based on location, categories or products. If you need to apply specific rules, you may learn more by pressing the “i” button.';
export const CARD_MENU_POSITION = { vertical: 'bottom', horizontal: 'bottom' };
